module.exports = __webpack_public_path__ + "img/file-exclamation.0f305b91.svg";